<lib-popup
  [id]="modalId()"
  [loading]="loading()"
  (closed)="closeAction()"
  (confirm)="applyCrop()"
  (cancelled)="cancelledAction()"
  confirmText="Recortar imagen"
>
  <div class="relative">
    <lib-screen-spinner [spinnerId]="modalId()"></lib-screen-spinner>
    <div #cropperContainer class="flex flex-col space-y-4">
      <!-- Contenedor del cropper con altura fija -->
      <div
        class="custom-height overflow-hidden"
        [ngClass]="{ 'contain-mode': getContainWithinAspectRatio() }"
      >
        @if (getFile()) {
          <image-cropper
            [imageFile]="getFile()!"
            [maintainAspectRatio]="true"
            [aspectRatio]="getAspectRatio()"
            [resizeToWidth]="getResizeToWidth()"
            [transform]="getTransform()"
            [containWithinAspectRatio]="getContainWithinAspectRatio()"
            [alignImage]="'center'"
            [onlyScaleDown]="false"
            [autoCrop]="true"
            (imageCropped)="imageCropped($event)"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
            class="w-full h-full"
          ></image-cropper>
        }
      </div>

      <!-- Controles adicionales -->
      <div class="flex flex-wrap gap-3">
        <button
          type="button"
          class="px-2 py-1 text-[12px] font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          (click)="rotateLeft()"
          title="Rotar a la izquierda"
        >
          <i class="fas fa-undo h-4 w-4"></i>
        </button>
        <button
          type="button"
          class="px-2 py-1 text-[12px] font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          (click)="rotateRight()"
          title="Rotar a la derecha"
        >
          <i class="fas fa-redo h-4 w-4"></i>
        </button>
        <button
          type="button"
          class="px-2 py-1 text-[12px] font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          (click)="flipHorizontal()"
          title="Voltear horizontalmente"
        >
          <i class="fas fa-arrows-alt-h h-4 w-4"></i>
        </button>
        <button
          type="button"
          class="px-2 py-1 text-[12px] font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          (click)="flipVertical()"
          title="Voltear verticalmente"
        >
          <i class="fas fa-arrows-alt-v h-4 w-4"></i>
        </button>
        <button
          type="button"
          [class]="
            getContainWithinAspectRatio()
              ? 'px-2 py-1 text-[12px] font-medium text-white bg-primary border border-transparent rounded-md shadow-sm hover:bg-primary focus:outline-none'
              : 'px-2 py-1 text-[12px] font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none'
          "
          (click)="toggleContainWithinAspectRatio()"
          [title]="
            getContainWithinAspectRatio() ? 'Desactivar modo contención' : 'Activar modo contención'
          "
        >
          <i class="fas fa-compress-alt h-4 w-4"></i>
        </button>
      </div>
    </div>
  </div>
</lib-popup>
